import { getConfig } from '../config/environments.js';
import type { Logger, LogLevel, LogEntry } from './types.js';

class AppLogger implements Logger {
  private shouldLog(level: LogLevel): boolean {
    const config = getConfig();
    const levels: LogLevel[] = ['debug', 'info', 'warn', 'error'];
    const currentLevelIndex = levels.indexOf(config.logLevel);
    const messageLevelIndex = levels.indexOf(level);
    
    return messageLevelIndex >= currentLevelIndex;
  }

  private log(level: LogLevel, message: string, data?: unknown): void {
    if (!this.shouldLog(level)) {
      return;
    }

    const entry: LogEntry = {
      level,
      message,
      data,
      timestamp: new Date().toISOString(),
    };

    const logData = data ? [message, data] : [message];

    switch (level) {
      case 'debug':
        console.debug(`[${entry.timestamp}] DEBUG:`, ...logData);
        break;
      case 'info':
        console.info(`[${entry.timestamp}] INFO:`, ...logData);
        break;
      case 'warn':
        console.warn(`[${entry.timestamp}] WARN:`, ...logData);
        break;
      case 'error':
        console.error(`[${entry.timestamp}] ERROR:`, ...logData);
        break;
    }
  }

  debug(message: string, data?: unknown): void {
    this.log('debug', message, data);
  }

  info(message: string, data?: unknown): void {
    this.log('info', message, data);
  }

  warn(message: string, data?: unknown): void {
    this.log('warn', message, data);
  }

  error(message: string, data?: unknown): void {
    this.log('error', message, data);
  }
}

export const logger = new AppLogger(); 